import { time } from '../../../frameloop/sync-time.mjs';
import { frame, cancelFrame, frameData } from '../../../frameloop/frame.mjs';
var frameloopDriver = function frameloopDriver(update) {
  var passTimestamp = function passTimestamp(_ref) {
    var timestamp = _ref.timestamp;
    return update(timestamp);
  };
  return {
    start: function start() {
      return frame.update(passTimestamp, true);
    },
    stop: function stop() {
      return cancelFrame(passTimestamp);
    },
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: function now() {
      return frameData.isProcessing ? frameData.timestamp : time.now();
    }
  };
};
export { frameloopDriver };